import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useEffect, useMemo, useState } from "react";
import { setFiscalYearDtl } from "@/redux/slices";
import { useGetFiscalYearDetails } from "@/services";

const useFiscalYearClosing = () => {
  const dispatch = useDispatch();
  const {communityData, currentFinanceYear, fiscalYearDtl} = useSelector(
    (state: RootState) => state.currentData
  );
  const [isValidationCompleted, setIsValidationCompleted] = useState<boolean>(false);

  // SAFE EXTRACTION
  const communityId = communityData?.communityId;
  const fiscalYear = currentFinanceYear;

  // CALL API ONLY WHEN VALUES EXIST
  const { data: fiscalYearData, isLoading: isFiscalDataLoading } = useGetFiscalYearDetails({
    communityId,
    fiscalYear
  });

  const isLocked = useMemo(() => {
    if (fiscalYearData) {
      return fiscalYearData?.status?.toLowerCase() == "locked"
    }
  }, [fiscalYearData]);

  useEffect(() => {
    if (fiscalYearData && JSON.stringify(fiscalYearData) != JSON.stringify(fiscalYearDtl)) {
      if (fiscalYearData?.fiscalYear == currentFinanceYear) {
        dispatch(setFiscalYearDtl(fiscalYearData))
      }
    }
  }, [fiscalYearData])

  const breadcrumbTitle = `Fiscal Year Closing - ${
    communityData?.communityName || communityData?.name || ""
  }`;

  const breadcrumbData = [
    {
      link: `/${routes.cam}/${routes.activityDashboard}`,
      name: `Activity Dashboard - ${communityData?.communityName || communityData?.name || ""}`,
    },
    {
      link: "",
      name: "Fiscal Year Closing",
    },
  ];

  return {
    breadcrumbTitle,
    breadcrumbData,
    communityId,
    fiscalYear,
    isFiscalDataLoading,
    fiscalYearData,
    isLocked,
    isValidationCompleted,
    setIsValidationCompleted
  };
};

export default useFiscalYearClosing;